import AutoSuite from './auto-suite';

const Mixins = {
    data: () => ({
        itemsList: [], //表单

        repeatCount: 0,
        cTimeout: ''
    }),
    created() {
    },
    mixins: [AutoSuite],
    mounted() {
        window.returnValue = (vals, extra) => {
            this.returnValue(vals, extra);
        };

        window.pickRelate = (availableTemplates, extra) => {
            window.tempRelate = {
                availableTemplates: availableTemplates,
                extra: {
                    ...extra,
                    returnType: 'pickRelate'
                }
            };
            this.PUSH({ name: 'approve-choice', query: {} });
        };
    },
    methods: {
        /**
         * js调原生后返回数据
         * @param val
         * @param extra js调原生时传过去的值
         */
        returnValue(val, extra) {
            console.log('returnValue', val, extra);
            let extraData = JSON.parse(extra);
            if (extraData.parentIndex != null) {
                let parentCmpt = this.itemsList[extraData.parentIndex];
                if (extraData.suiteIndex != null) {
                    parentCmpt = parentCmpt.children[extraData.suiteIndex];
                }
                if (extraData.tableIndex != null && extraData.tableChildIndex != null) {
                    parentCmpt = parentCmpt.children[extraData.tableIndex][extraData.tableChildIndex];
                }
                if (extraData.returnType == 'pickImage' ||
                    extraData.returnType == 'pickAttach' ||
                    extraData.returnType == 'pickDocument' ||
                    extraData.returnType == 'pickRelate') {
                    this.addArrayValue(parentCmpt, val);
                } else if (extraData.returnType == 'pickCustomer' ||
                    extraData.returnType == 'pickDep' ||
                    extraData.returnType == 'pickUser' ||
                    extraData.returnType == 'pickRole') {
                    this.setArrayValue(parentCmpt, val);
                } else if (extraData.returnType == 'pickLocation') {
                    let newVal = JSON.parse(val);
                    newVal.time = new Date();
                    this.setValue(parentCmpt, newVal);
                } else if (extraData.returnType == 'pickDate') {
                    let newVal = moment(val).format('YYYY-MM-DD');
                    if (extraData.range != null) {
                        this.setValueRange(parentCmpt, newVal, extraData.range);
                        parentCmpt.value[2] = this.calculateDuration(parentCmpt);
                    } else {
                        this.setValue(parentCmpt, newVal);
                    }
                } else if (extraData.returnType == 'pickTime') {
                    let newVal = moment(val).format('YYYY-MM-DD HH:mm');
                    if (extraData.range != null) {
                        this.setValueRange(parentCmpt, newVal, extraData.range);
                        parentCmpt.value[2] = this.calculateDuration(parentCmpt);
                    } else {
                        this.setValue(parentCmpt, newVal);
                    }
                } else if (extraData.returnType == 'pickSingle') {
                    let newVal = JSON.parse(val).text;
                    this.setValue(parentCmpt, newVal);
                }
            }
        },

        /**
         * 在原有数组数据上叠加
         * @param val
         * @param extra js调原生时传过去的值
         */
        addArrayValue(cmpt, val) {
            cmpt.value.push(...JSON.parse(val));
        },


        /**
         * 替换原有数组数据
         * @param val
         * @param extra js调原生时传过去的值
         */
        setArrayValue(cmpt, val) {
            cmpt.value.splice(0, cmpt.value.length, ...JSON.parse(val));
        },

        /**
         * 替换原有对象数据
         * @param val
         * @param extra js调原生时传过去的值
         */
        setValue(cmpt, val) {
            cmpt.value = val;
        },

        /**
         * 替换原有对象数据
         * @param val
         * @param extra js调原生时传过去的值
         */
        setValueRange(cmpt, val, range) {
            cmpt.value.splice(range, 1, val);
        },


        calculateDuration(cmpt) {
            if (cmpt.value[0] && cmpt.value[1]) {
                let start = moment(cmpt.value[0]);
                let end = moment(cmpt.value[1]);
                if (cmpt.props.unit == '天') {
                    return end.diff(start, 'day') + 1;
                } else if (cmpt.props.unit == '小时') {
                    return end.diff(start, 'hour');
                }
            }
            return '';
        },

        /**
         * 检查表单是否所有必填项都已填写
         * @param cmpts 表单
         * @returns {{success: boolean}}
         */
        checkEmpty(cmpts) {
            let result = { success: true };
            for (let i = 0; i < cmpts.length; i++) {
                let cmpt = cmpts[i];
                result = this.isComponentValueEmpty(cmpt, { parentIndex: i });
                if (!result.success) {
                    break;
                }
            }
            return result;
        },

        /**
         * 检查单个表单是否填写符合必填要求
         * @param cmpt 组件
         * @param extra 位置属性
         * @returns {{success: boolean, label: string, extra: *}}
         */
        isComponentValueEmpty(cmpt, extra) {
            console.log('isComponentValueEmpty', cmpt, extra);
            let label = '';
            let success = true;
            let errorExtra = _.cloneDeep(extra);
            if (cmpt.componentName == 'DateRangeField') {
                if (cmpt.props.required && !cmpt.value[0]) {
                    label = cmpt.props.label[0];
                    success = false;
                } else if (cmpt.props.required && !cmpt.value[1]) {
                    label = cmpt.props.label[1];
                    success = false;
                }
            } else if (cmpt.componentName == 'MultiSelectField' ||
                cmpt.componentName == 'PhotoField' ||
                cmpt.componentName == 'Attachment' ||
                cmpt.componentName == 'RelateField' ||
                cmpt.componentName == 'DepartmentField' ||
                cmpt.componentName == 'InnerContactField' ||
                cmpt.componentName == 'HrField' ||
                cmpt.componentName == 'DocumentField' ||
                cmpt.componentName == 'ExternalContactField') {
                success = !cmpt.props.required || (cmpt.value && cmpt.value.length > 0);
                label = cmpt.props.label;
            } else if (cmpt.componentName == 'TimeAndLocationField') {
                success = !cmpt.props.required || (cmpt.value && cmpt.value.address);
                label = cmpt.props.label;
            } else if (cmpt.componentName == 'TableField') {
                for (let i = 0; i < cmpt.children.length; i++) {
                    let table = cmpt.children[i];
                    for (let j = 0; j < table.length; j++) {
                        errorExtra = {
                            ...extra,
                            tableIndex: i,
                            tableChildIndex: j
                        };
                        let result = this.isComponentValueEmpty(table[j], errorExtra);
                        success = result.success;
                        label = result.label;
                        if (!success) {
                            break;
                        }
                    }
                    if (!success) {
                        break;
                    }
                }
            } else if (this.isSuiteCompnent(cmpt.componentName)) {
                for (let i = 0; i < cmpt.children.length; i++) {
                    errorExtra = {
                        ...extra,
                        suiteIndex: i
                    };
                    let result = this.isComponentValueEmpty(cmpt.children[i], errorExtra);
                    success = result.success;
                    label = result.label;
                    if (!success) {
                        break;
                    }
                }
            } else if (cmpt.componentName == 'PurchaseQuotedPriceField') {
                success = !cmpt.props.required || (cmpt.value && cmpt.value['quotationResult'] && Object.keys(cmpt.value['quotationResult']).length == cmpt.value['productTotal']);
                label = cmpt.props.label;
            } else {
                success = !cmpt.props.required || cmpt.value;
                label = cmpt.props.label;
            }
            let result = { success: success, label: label, extra: errorExtra };
            return result;
        },

        /**
         * 提示并滚动到指定组件
         * @param label
         * @param extra
         */
        showEmptyTip(label, extra) {
            let id = 'cmpt-' + JSON.stringify(extra);
            try {
                this.ScrollToControl(id);
            } catch (e) {
                console.log(e);
            }
            this.$toast({
                type: 'text',
                forbidClick: true,
                message: label + '不能为空',
                duration: 1000
            });
        },

        elementPosition(obj) {
            let curleft = 0;
            let curtop = 0;
            if (obj.offsetParent) {
                curleft = obj.offsetLeft;
                curtop = obj.offsetTop;
                // eslint-disable-next-line
                while (obj = obj.offsetParent) {
                    curleft += obj.offsetLeft;
                    curtop += obj.offsetTop;
                }
            }
            return { x: curleft, y: curtop };
        },

        ScrollToControl(id) {
            var elem = document.getElementById(id);
            var scrollPos = this.elementPosition(elem).y;
            scrollPos = scrollPos - document.documentElement.scrollTop;
            var remainder = scrollPos % 50;
            var repeatTimes = Math.abs(scrollPos - remainder) / 50;
            this.ScrollSmoothly(scrollPos, repeatTimes);
            window.scrollBy(0, remainder);
        },

        ScrollSmoothly(scrollPos, repeatTimes) {
            if (this.repeatCount < repeatTimes) {
                if (scrollPos > 0) {
                    window.scrollBy(0, 50);
                } else {
                    window.scrollBy(0, -50);
                }
            } else {
                this.repeatCount = 0;
                clearTimeout(this.cTimeout);
                return;
            }
            this.repeatCount++;
            this.cTimeout = setTimeout(this.ScrollSmoothly(scrollPos, repeatTimes), 10);
        },

        loopCompnents(cmpts) {
            let awResultList = [];
            let result = this.loopCompnents2(cmpts, awResultList);

            awResultList = _.uniqBy(awResultList, this.uniqByPrimary);
            awResultList.forEach((aw) => {
                // console.log('autoWriteResult', aw.key, JSON.stringify(aw.content), aw.search);
                //TODO 保存数据, 若与search中的键值对都相同或不存在search中的键，则删除旧数据
                this.$indexedDB.saveAutoFillData(aw.key, aw.content, aw.search);
            });
            return result;
        },

        uniqByPrimary(data) {
            return JSON.stringify(data.search);
        },

        /**
         * 递归遍历所有组件的值
         * @param cmpts
         */
        loopCompnents2(cmpts, awResultList) {
            let result = {};
            let autoWriteList = [];
            let autoWriteMap = {};
            for (let i = 0; i < cmpts.length; i++) {
                let cmpt = cmpts[i];
                let temp;
                if (cmpt.componentName == 'RelateField') {
                    temp = _.cloneDeep(cmpt.value);
                    for (let j = 0; j < temp.length; j++) {
                        delete temp[j].statusCd;
                    }
                } else if (cmpt.componentName == 'TableField') {
                    temp = [];
                    for (let j = 0; j < cmpt.children.length; j++) {
                        let childResult = this.loopCompnents2(cmpt.children[j], awResultList);
                        console.log('childResult', childResult);
                        temp.push(childResult);
                    }
                } else if (this.isSuiteCompnent(cmpt.componentName)) {
                    temp = this.loopCompnents2(cmpt.children, awResultList);
                } else {
                    temp = cmpt.value;
                }
                result[cmpt.props.id] = temp;
                //自动填充
                if (cmpt.autoWrite && cmpt.autoWrite.modelId && cmpt.autoWrite.key) {
                    let autoWirteTemp = _.cloneDeep(cmpt.autoWrite);
                    autoWirteTemp.value = temp;
                    autoWriteList.push(autoWirteTemp);
                    if (!autoWriteMap[cmpt.autoWrite.modelId]) {
                        autoWriteMap[cmpt.autoWrite.modelId] = {
                            key: cmpt.autoWrite.modelId,
                            content: {},
                            search: {}
                        };
                    }
                }
            }
            autoWriteList.forEach(function (autoWrite) {
                let mapItem = autoWriteMap[autoWrite.modelId];
                if (mapItem) {
                    if (autoWrite.primary && !autoWrite.value) {
                        delete autoWriteMap[autoWrite.modelId];
                    } else {
                        mapItem.content[autoWrite.key] = autoWrite.value;
                        if (autoWrite.primary) {
                            mapItem.search[autoWrite.key] = autoWrite.value;
                        }
                    }
                }
            });
            for (let key in autoWriteMap) {
                awResultList.push(autoWriteMap[key]);
            }
            return result;
        },

        /**
         * 获取列表展示的内容
         * @param cmpts
         * @param content
         * @returns {Array}
         */
        listDetails(cmpts, content) {
            console.log('listDetails', cmpts, content);
            let listDetail = []; //列表展示字段
            for (let i = 0; i < cmpts.length; i++) {
                if (listDetail.length >= 2) {
                    break;
                }
                let cmpt = cmpts[i];
                let temp = content[cmpt.props.id];
                if (cmpt.props.hide == true || !temp) {
                    continue;
                }
                //图片、附件、明细、说明文字、人力资源、关联审批单不计入列表展示
                if (cmpt.componentName == 'PhotoField' ||
                    cmpt.componentName == 'Attachment' ||
                    cmpt.componentName == 'TableField' ||
                    cmpt.componentName == 'TextNote' ||
                    cmpt.componentName == 'HrField' ||
                    cmpt.componentName == 'RelateField') {
                    continue;
                }

                if (this.isSuiteCompnent(cmpt.componentName)) {
                    listDetail.push(...this.listDetails(cmpt.children, temp));
                } else if (cmpt.componentName == 'DateRangeField') {
                    listDetail.push({ label: cmpt.props.label[0], value: temp[0] });
                    listDetail.push({ label: cmpt.props.label[1], value: temp[1] });
                    if (cmpt.props.duration) {
                        listDetail.push({
                            label: cmpt.props.durationLabel + '(' + cmpt.props.unit + ')',
                            value: temp[2]
                        });
                    }
                } else if (cmpt.componentName == 'TimeAndLocationField') {
                    listDetail.push({ label: cmpt.props.label, value: temp.address });
                } else if (cmpt.componentName == 'DepartmentField') {
                    listDetail.push({ label: cmpt.props.label, value: this.detailListName(temp, 'depName', '部门') });
                } else if (cmpt.componentName == 'InnerContactField') {
                    listDetail.push({ label: cmpt.props.label, value: this.detailListName(temp, 'realName', '人') });
                } else if (cmpt.componentName == 'ExternalContactField') {
                    listDetail.push({ label: cmpt.props.label, value: this.detailListName(temp, 'customerName', '人') });
                } else if (cmpt.componentName == 'MultiSelectField') {
                    listDetail.push({ label: cmpt.props.label, value: temp.join('、') });
                } else if (cmpt.componentName == 'DocumentField') {
                    listDetail.push({ label: cmpt.props.label, value: this.detailListName(temp, 'title', '个文档') });
                } else {
                    listDetail.push({ label: cmpt.props.label, value: temp });
                }
            }
            return listDetail;
        },

        /**
         * 数组展示文本
         * @param dataList 数组数据源
         * @param fieldName 展示的字段名
         * @param stuff 后缀
         * @returns {*}
         */
        detailListName(dataList, fieldName, stuff) {
            if (!dataList || dataList.length == 0) {
                return '';
            }
            if (dataList.length > 1) {
                return dataList[0][fieldName] + '等' + dataList.length + stuff;
            }
            return dataList[0][fieldName];
        },

        /**
         * 获取condition对应的值
         * @param conditionData
         * @param content
         * @returns {{condition, hrProperty}}
         */
        loopCondition(conditionData, content) {
            console.log('loopCondition', conditionData, content);
            //条件审批判断
            let condition = {};
            let hrProperty = {};
            if (conditionData) {
                let a = JSON.parse(conditionData);
                for (let i = 0; i < a.length; i++) {
                    let key = a[i]['paramKey'];
                    let value = this.getConditionByContent(content, key).value;
                    if (a[i].type == 'user_condition') {
                        if (value && value.length) {
                            condition[key] = Number(value[0].profileId);
                        } else {
                            condition[key] = '';
                        }
                    } else if (a[i].type == 'target_hr') {
                        let itemValue = [];
                        if (value && value.length > 0) {
                            for (let j = 0; j < value.length; j++) {
                                itemValue.push(Number(value[j].profileId));
                            }
                        }
                        hrProperty[key] = itemValue;
                    } else if (a[i].type == 'dep_condition') {
                        if (value && value.length > 0) {
                            condition[key] = Number(value[0].depId);
                        } else {
                            condition[key] = '';
                        }
                    } else {
                        condition[key] = value || '';
                    }
                }
            }

            return {
                condition: condition,
                hrProperty: hrProperty
            };
        },

        getConditionByContent(content, id) {
            let result = {
                value: '',
                found: false
            };
            if (content) {
                for (let key in content) {
                    let compnentName = key.split('-')[0];
                    if (this.isSuiteCompnent(compnentName)) {
                        let temp = this.getConditionByContent(content[key], id);
                        if (temp.found) {
                            return temp;
                        }
                    } else if (key == id) {
                        result.value = content[key];
                        result.found = true;
                        break;
                    }
                }
            }
            return result;
        }
    }
};

export default Mixins;
